import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Container from "react-bootstrap/Container";
import {printLogbook} from "../../api/skyduck";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import {getEmail} from "../../storage/user";
import * as ReactGA from "react-ga";

const {useEffect} = require("react");

export function PrintLogbook() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        ReactGA.modalview('/print-logbook');
    }

    const [units, setUnits] = React.useState('metric');
    const [date, setDate] = React.useState('european');
    const [page, setPage] = React.useState('a4');
    const [printFormat, setPrintFormat] = React.useState('singleSide');
    const [email, setEmail] = React.useState(getEmail() ? getEmail() : '');

    return (
        <>
            <Button variant="primary" onClick={handleShow} className="mb-3 mt-1">
                Print PDF logbook
            </Button>

            <Modal show={show}
                   onHide={handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Print PDF logbook
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <label>Units:</label>
                        <InputGroup className="mb-3">
                            <ToggleButtonGroup type="radio" name="options" value={units} onChange={setUnits}>
                                <ToggleButton value="metric">Metric</ToggleButton>
                                <ToggleButton value="imperial">Imperial</ToggleButton>
                            </ToggleButtonGroup>
                        </InputGroup>

                        <label>Date format:</label>
                        <InputGroup className="mb-3">
                            <ToggleButtonGroup type="radio" name="options" value={date} onChange={setDate}>
                                <ToggleButton value="european">European</ToggleButton>
                                <ToggleButton value="us">US</ToggleButton>
                            </ToggleButtonGroup>
                        </InputGroup>

                        <label>Page format:</label>
                        <InputGroup className="mb-3">
                            <ToggleButtonGroup type="radio" name="options" value={page} onChange={setPage}>
                                <ToggleButton value="a4">A4</ToggleButton>
                                <ToggleButton value="letter">US Letter</ToggleButton>
                            </ToggleButtonGroup>
                        </InputGroup>

                        <label>Print format:</label>
                        <InputGroup className="mb-3">
                            <ToggleButtonGroup type="radio" name="options" value={printFormat} onChange={setPrintFormat}>
                                <ToggleButton value="singleSide">Single side</ToggleButton>
                                <ToggleButton value="doubleSide">Double side</ToggleButton>
                            </ToggleButtonGroup>
                        </InputGroup>

                        <label>Email:</label>
                        <InputGroup className="mb-3">
                            <Form.Control
                                required
                                onChange={event => setEmail(event.target.value)}
                                value={email}
                            />
                        </InputGroup>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <SendLogbookButton
                        units={units}
                        date={date}
                        page={page}
                        printFormat={printFormat}
                        email={email}
                        handleClose={handleClose}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
}

function SendLogbookButton(props) {
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            printLogbook(props.units,
                props.date,
                props.page,
                props.printFormat,
                props.email).then(() => {
                    ReactGA.event({
                        category: 'User',
                        action: 'Printed PDF logbook'
                    });
                    props.handleClose();
                });
        }
    }, [isLoading]);

    const handleClick = () => setLoading(true);

    return (
        <Button
            variant="primary"
            disabled={isLoading}
            onClick={!isLoading ? handleClick : null}
        >
            {isLoading ? 'Sending...' : 'Send Logbook'}
        </Button>
    );
}